// Per-model SEO landing pages (autonomie, recharge, bornes).
// Dependency-free (no imports) so the prerender script can load it too.
export const MODEL_PATH = "/voiture-sans-permis";

export const MODELS = [
  {
    slug: "citroen-ami",
    brand: "Citroën",
    name: "Citroën Ami",
    energy: "100 % électrique",
    metaTitle: "Citroën Ami : autonomie, recharge et bornes | vspo",
    metaDescription:
      "Citroën Ami : autonomie réelle (~75 km), recharge sur prise domestique 220 V, type de prise et astuces. Trouvez une borne compatible et calculez vos trajets 45 km/h avec vspo.",
    kicker: "Citroën Ami",
    h1: "Citroën Ami : autonomie, recharge et bornes",
    intro:
      "La Citroën Ami est l'une des voitures sans permis électriques les plus populaires en ville. Voici l'essentiel sur son autonomie, sa recharge et comment trouver une borne compatible avec vspo.",
    specs: [
      { label: "Énergie", value: "100 % électrique" },
      { label: "Autonomie", value: "environ 75 km (usage urbain)" },
      { label: "Recharge", value: "prise domestique 220 V (câble intégré), ~3 à 4 h" },
      { label: "Type de prise", value: "domestique E/F" },
      { label: "Vitesse", value: "45 km/h (quadricycle léger)" },
    ],
    body: [
      {
        h2: "Quelle autonomie pour la Citroën Ami ?",
        paragraphs: [
          "La Citroën Ami annonce environ 75 km d'autonomie, largement suffisant pour les trajets urbains du quotidien à 45 km/h. L'autonomie réelle varie selon la température, le relief et le style de conduite.",
          "Dans vspo, activez le suivi de batterie pour être alerté quand l'autonomie devient faible (sous 20 km pour l'Ami) et anticiper la recharge.",
        ],
      },
      {
        h2: "Comment recharger la Citroën Ami ?",
        paragraphs: [
          "L'Ami se recharge sur une simple prise domestique 220 V grâce à son câble intégré : comptez environ 3 à 4 heures pour une charge complète, idéalement la nuit. Aucune borne spéciale n'est nécessaire à domicile.",
          "En déplacement, certaines bornes publiques proposent une prise domestique (E/F) compatible. Dans vspo, filtrez les bornes par type de prise pour trouver celles qui conviennent à l'Ami.",
        ],
      },
      {
        h2: "Trouver une borne et calculer un trajet",
        paragraphs: [
          "vspo trace des itinéraires adaptés aux 45 km/h, sans autoroute ni voie rapide, et peut proposer un arrêt recharge sur le trajet si l'autonomie ne suffit pas. Pratique pour rouler l'esprit tranquille en Ami.",
        ],
      },
    ],
    faq: [
      {
        q: "Peut-on recharger la Citroën Ami sur une borne publique ?",
        a: "Oui, sur les bornes proposant une prise domestique (E/F). vspo permet de filtrer les bornes par type de prise.",
      },
      {
        q: "Quelle est l'autonomie réelle de l'Ami ?",
        a: "Environ 75 km en usage urbain, variable selon la météo, le relief et la conduite.",
      },
    ],
  },
  {
    slug: "aixam",
    brand: "Aixam",
    name: "Aixam",
    energy: "thermique & électrique (e-Aixam)",
    metaTitle: "Aixam : autonomie, recharge et bornes (VSP) | vspo",
    metaDescription:
      "Voiture sans permis Aixam : autonomie thermique et électrique (e-Aixam), recharge, type de prise et bornes compatibles. Calculez vos itinéraires 45 km/h avec vspo.",
    kicker: "Aixam",
    h1: "Aixam : autonomie, recharge et bornes",
    intro:
      "Aixam est l'un des principaux constructeurs français de voitures sans permis, avec des versions thermiques et une gamme électrique (e-Aixam). Voici l'essentiel sur l'autonomie et la recharge.",
    specs: [
      { label: "Énergie", value: "diesel bicylindre ou électrique (e-Aixam)" },
      { label: "Autonomie électrique", value: "jusqu'à ~75 km selon la version" },
      { label: "Recharge", value: "prise domestique ou borne selon modèle" },
      { label: "Type de prise", value: "domestique E/F (vérifier selon version)" },
      { label: "Vitesse", value: "45 km/h (quadricycle léger)" },
    ],
    body: [
      {
        h2: "Thermique ou électrique ?",
        paragraphs: [
          "Les Aixam thermiques utilisent un petit moteur diesel bicylindre très sobre, avec une grande autonomie grâce au réservoir. La gamme e-Aixam, électrique, vise les trajets urbains du quotidien.",
          "Selon la version électrique, l'autonomie se situe autour de 75 km ; vérifiez toujours la fiche du modèle exact.",
        ],
      },
      {
        h2: "Recharge d'une e-Aixam",
        paragraphs: [
          "Une e-Aixam se recharge généralement sur une prise domestique renforcée, souvent la nuit. Certaines versions acceptent une borne publique : contrôlez le type de connecteur de votre véhicule.",
          "Dans vspo, filtrez les bornes par type de prise et par puissance pour trouver un point de charge adapté près de votre trajet.",
        ],
      },
      {
        h2: "Itinéraires adaptés avec vspo",
        paragraphs: [
          "Quelle que soit la motorisation, vspo évite autoroutes et voies rapides et calcule à 45 km/h. Pour les versions électriques, activez le suivi de batterie et l'arrêt recharge sur le trajet.",
        ],
      },
    ],
    faq: [
      {
        q: "L'Aixam existe-t-elle en électrique ?",
        a: "Oui, la gamme e-Aixam est électrique ; les versions thermiques utilisent un moteur diesel bicylindre.",
      },
    ],
  },
  {
    slug: "ligier",
    brand: "Ligier",
    name: "Ligier",
    energy: "thermique & électrique (Myli)",
    metaTitle: "Ligier : autonomie, recharge et bornes (VSP) | vspo",
    metaDescription:
      "Voiture sans permis Ligier : autonomie thermique et électrique (Ligier Myli, jusqu'à ~192 km), recharge, type de prise et bornes. Itinéraires 45 km/h avec vspo.",
    kicker: "Ligier",
    h1: "Ligier : autonomie, recharge et bornes",
    intro:
      "Ligier propose des voitures sans permis thermiques (gamme JS) et électriques, dont la Ligier Myli qui vise une autonomie élevée pour une VSP. Voici l'essentiel.",
    specs: [
      { label: "Énergie", value: "essence/diesel ou électrique (Myli)" },
      { label: "Autonomie électrique", value: "jusqu'à ~192 km selon la batterie (Myli)" },
      { label: "Recharge", value: "prise domestique ou borne Type 2 selon version" },
      { label: "Type de prise", value: "domestique E/F ou Type 2 (selon version)" },
      { label: "Vitesse", value: "45 km/h (quadricycle léger)" },
    ],
    body: [
      {
        h2: "La gamme Ligier",
        paragraphs: [
          "Ligier est un constructeur français historique de voiturettes. Les modèles thermiques offrent une grande autonomie ; la Ligier Myli électrique propose, selon la taille de batterie, jusqu'à environ 192 km — une valeur élevée pour une VSP.",
          "Vérifiez toujours l'autonomie annoncée pour la version exacte, car elle dépend de la batterie choisie.",
        ],
      },
      {
        h2: "Recharge d'une Ligier électrique",
        paragraphs: [
          "Selon la version, la recharge se fait sur prise domestique ou sur borne (parfois en Type 2). Contrôlez le connecteur de votre véhicule avant de vous rendre à une borne.",
          "vspo permet de filtrer les bornes par type de prise et par puissance pour trouver un point compatible sur votre itinéraire.",
        ],
      },
      {
        h2: "Rouler malin avec vspo",
        paragraphs: [
          "vspo calcule des trajets à 45 km/h sans autoroute ni voie rapide, affiche le trafic en temps réel et peut insérer un arrêt recharge si besoin.",
        ],
      },
    ],
    faq: [
      {
        q: "Quelle autonomie pour la Ligier Myli ?",
        a: "Jusqu'à environ 192 km selon la batterie choisie ; l'autonomie réelle varie avec l'usage.",
      },
    ],
  },
  {
    slug: "microcar",
    brand: "Microcar",
    name: "Microcar",
    energy: "thermique & électrique",
    metaTitle: "Microcar : autonomie, recharge et bornes (VSP) | vspo",
    metaDescription:
      "Voiture sans permis Microcar (M.Go…) : autonomie thermique et électrique, recharge, type de prise et bornes compatibles. Calculez vos trajets 45 km/h avec vspo.",
    kicker: "Microcar",
    h1: "Microcar : autonomie, recharge et bornes",
    intro:
      "Microcar, marque du groupe Ligier, propose des voitures sans permis thermiques (comme la M.Go) et des versions électriques. Voici l'essentiel sur l'autonomie et la recharge.",
    specs: [
      { label: "Énergie", value: "diesel bicylindre ou électrique" },
      { label: "Autonomie électrique", value: "usage urbain selon la version" },
      { label: "Recharge", value: "prise domestique ou borne selon modèle" },
      { label: "Type de prise", value: "domestique E/F ou Type 2 (selon version)" },
      { label: "Vitesse", value: "45 km/h (quadricycle léger)" },
    ],
    body: [
      {
        h2: "Les Microcar thermiques et électriques",
        paragraphs: [
          "Les versions thermiques (ex. M.Go) offrent une grande autonomie grâce au réservoir, tandis que les versions électriques ciblent les déplacements urbains du quotidien.",
          "L'autonomie électrique dépend de la version : consultez la fiche du modèle exact pour une valeur précise.",
        ],
      },
      {
        h2: "Recharge et bornes",
        paragraphs: [
          "Selon la motorisation électrique, la recharge se fait sur prise domestique ou sur borne. Vérifiez le connecteur du véhicule, puis utilisez vspo pour filtrer les bornes par type de prise et puissance.",
        ],
      },
      {
        h2: "Itinéraires VSP avec vspo",
        paragraphs: [
          "vspo évite autoroutes et voies rapides, calcule à 45 km/h et propose au besoin un arrêt recharge sur le trajet.",
        ],
      },
    ],
    faq: [
      {
        q: "Microcar propose-t-elle des modèles électriques ?",
        a: "Oui, aux côtés des versions thermiques comme la M.Go. Vérifiez l'autonomie de la version exacte.",
      },
    ],
  },
  {
    slug: "chatenet",
    brand: "Chatenet",
    name: "Chatenet",
    energy: "thermique & électrique",
    metaTitle: "Chatenet : autonomie, recharge et bornes (VSP) | vspo",
    metaDescription:
      "Voiture sans permis Chatenet (CH26, Sporteevo…) : autonomie, recharge électrique, type de prise et bornes compatibles. Itinéraires 45 km/h avec vspo.",
    kicker: "Chatenet",
    h1: "Chatenet : autonomie, recharge et bornes",
    intro:
      "Chatenet est un constructeur français de voitures sans permis au style affirmé (CH26, Sporteevo…), avec des versions thermiques et électriques. Voici l'essentiel.",
    specs: [
      { label: "Énergie", value: "diesel bicylindre ou électrique" },
      { label: "Autonomie électrique", value: "usage urbain selon la version" },
      { label: "Recharge", value: "prise domestique ou borne selon modèle" },
      { label: "Type de prise", value: "domestique E/F ou Type 2 (selon version)" },
      { label: "Vitesse", value: "45 km/h (quadricycle léger)" },
    ],
    body: [
      {
        h2: "La gamme Chatenet",
        paragraphs: [
          "Chatenet soigne le design de ses voiturettes. Les versions thermiques offrent une bonne autonomie ; les versions électriques visent les trajets urbains.",
          "L'autonomie électrique dépend du modèle et de la batterie : vérifiez la fiche de la version exacte.",
        ],
      },
      {
        h2: "Recharge et bornes compatibles",
        paragraphs: [
          "Pour une Chatenet électrique, contrôlez le type de connecteur avant de vous rendre à une borne. vspo permet de filtrer les bornes par type de prise et par puissance.",
        ],
      },
      {
        h2: "Trajets adaptés avec vspo",
        paragraphs: [
          "vspo calcule des itinéraires à 45 km/h sans autoroute ni voie rapide, avec trafic en temps réel et arrêt recharge optionnel.",
        ],
      },
    ],
    faq: [
      {
        q: "Chatenet fabrique-t-elle des VSP électriques ?",
        a: "Oui, en plus des versions thermiques. L'autonomie varie selon le modèle et la batterie.",
      },
    ],
  },
  {
    slug: "bellier",
    brand: "Bellier",
    name: "Bellier",
    energy: "électrique & thermique",
    metaTitle: "Bellier : autonomie, recharge et bornes (VSP) | vspo",
    metaDescription:
      "Voiture sans permis Bellier (B8, Divane…) : autonomie électrique, recharge, type de prise et bornes compatibles. Calculez vos itinéraires 45 km/h avec vspo.",
    kicker: "Bellier",
    h1: "Bellier : autonomie, recharge et bornes",
    intro:
      "Bellier est un constructeur français de voitures sans permis proposant des modèles électriques (comme la B8) et thermiques. Voici l'essentiel sur l'autonomie et la recharge.",
    specs: [
      { label: "Énergie", value: "électrique ou diesel bicylindre" },
      { label: "Autonomie électrique", value: "usage urbain selon la version" },
      { label: "Recharge", value: "prise domestique ou borne selon modèle" },
      { label: "Type de prise", value: "domestique E/F ou Type 2 (selon version)" },
      { label: "Vitesse", value: "45 km/h (quadricycle léger)" },
    ],
    body: [
      {
        h2: "Les voiturettes Bellier",
        paragraphs: [
          "Bellier propose des VSP électriques et thermiques. Les versions électriques ciblent les trajets urbains du quotidien, avec une autonomie variable selon la batterie.",
          "Consultez la fiche du modèle exact pour connaître l'autonomie annoncée.",
        ],
      },
      {
        h2: "Recharge et bornes",
        paragraphs: [
          "Pour une Bellier électrique, vérifiez le connecteur de votre véhicule, puis repérez une borne compatible. vspo filtre les bornes par type de prise et par puissance.",
        ],
      },
      {
        h2: "Rouler serein avec vspo",
        paragraphs: [
          "vspo évite autoroutes et voies rapides, calcule à 45 km/h et peut ajouter un arrêt recharge sur le trajet si nécessaire.",
        ],
      },
    ],
    faq: [
      {
        q: "Bellier propose-t-elle des modèles électriques ?",
        a: "Oui, comme la B8, en plus de versions thermiques. L'autonomie dépend de la version.",
      },
    ],
  },
];

export function findModel(slug) {
  return MODELS.find((m) => m.slug === slug) || null;
}
